module.exports = __webpack_public_path__ + "static/media/15.0e6e77a4.svg";